import { ReactComponent as Star } from "../../../images/Star-full.svg"
import { Button } from "semantic-ui-react"
import { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { routerPaths } from "../../../v1/constants/paths"
import { getEarnedMiles } from "../../../v1/actions/rewards"
import SplitClient, { REWARDS } from "../../../v1/components/Config/SplitClient"
import { APP_NAME } from "../../../shared_component/constants/common"

const RewardsDashboardCard = ({ history, getEarnedMiles, rewards, user }) => {
  const points = rewards?.pendingMiles
  const [isRewardsEnabled, setIsRewardsEnabled] = useState(false)

  useEffect(() => {
    getEarnedMiles()
    checkRewardsFlag()
  }, [])

  async function checkRewardsFlag(retries = 3) {
    const rewards = await SplitClient.getTreatment(REWARDS, user, {
      app_name: APP_NAME
    })

    const value = rewards?.[REWARDS]

    if (value === "control" && retries > 0) {
      await new Promise((res) => setTimeout(res, 1000))
      return checkRewardsFlag(retries - 1)
    }

    setIsRewardsEnabled(value === "on")
  }

  if (!isRewardsEnabled) {
    return null
  }

  return (
    <div className="rewards-dashboard-card">
      <div className="card-inner">
        <div className="card-header">
          <div className="header-text">
            <p className="title">{points ? "Rewards Balance" : "Kickstart your Rewards"}</p>
            {!points && (
              <p className="subtitle">
                Keep your vehicle in top shape and get rewarded along the way.
              </p>
            )}
            {points > 0 && (
              <p className="available-points">
                <span className="points">{points?.toLocaleString()} pts</span>
                <span className="amount">
                  {" "}
                  = ${(points / rewards?.milesPerDollar ?? 100)?.toLocaleString()}
                </span>
              </p>
            )}
          </div>

          <div className="header-icon">
            <Star width={40} height={20} />
          </div>
        </div>

        <div className="cta-wrapper" onClick={() => history.push(routerPaths.serviceRequest)}>
          <Button className="cta-button">{points ? "Redeem points" : "Book service now"}</Button>
        </div>

        <div className="background-accent" />
      </div>
    </div>
  )
}
function mapStateToProps(state) {
  return {
    rewards: state.rewards,
    user: state.user
  }
}

export default withRouter(
  connect(mapStateToProps, {
    getEarnedMiles
  })(RewardsDashboardCard)
)
